// Port of api/fuel/app/classes/insights/plays/hindex.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'hindex',
    types: [Constants.TYPE_USER],
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        if (detail) {

            var gamesIndex = Util.queryFast(
                'SELECT p.game_id AS game, SUM(p.play_count) AS plays' +
                ' FROM play p' +
                ' JOIN game g ON p.game_id = g.game_id AND g.game_type = 1' +
                ' WHERE p.user_id = ' + owner.get_id() +
                ' GROUP BY p.game_id' +
                ' HAVING SUM(p.play_count) >= ' + owner.get_hindex() +
                ' ORDER BY SUM(p.play_count) DESC, g.game_name ASC'
            )

            var games = []

            for (var i = 0; i < gamesIndex.length; i++) {
                var game = gamesIndex[i]

                this._references.games.push(parseInt(game.game, 10))

                games.push({
                    id: parseInt(game.game, 10),
                    plays: parseInt(game.plays, 10)
                })
            }

            return {
                hindex: games,
                score: owner.get_hindex()
            }

        } else {

            var data = {
                hindex: {},
                hindexStart: 0
            }

            var logs = Util.queryFast(
                'SELECT log_date, log_hindex' +
                ' FROM log_user_hindex' +
                ' WHERE user_id = ' + owner.get_id() +
                ' AND hindex_id = 1' +
                ' AND log_date > ' + (Util.time() - (Constants.TIME_YEAR * 10)) +
                ' ORDER BY log_date ASC'
            )

            for (var li = 0; li < logs.length; li++) {
                var log = logs[li]
                var stamp = Util.date('m', log.log_date) + '.' + Util.date('y', log.log_date)

                if (!data.hindexStart) data.hindexStart = parseInt(log.log_date, 10)

                data.hindex[stamp] = parseInt(log.log_hindex, 10)
            }

            return data

        }

    }
})
